export enum ACTION_TYPES {
  DEPOSIT = 'DEPOSIT',
  BORROW = 'BORROW',
  REPAY = 'REPAY',
  WITHDRAW = 'WITHDRAW',
}

export type ACTION = {
  label: string
  value: ACTION_TYPES
}

export const BORROW_ACTIONS: ACTION[] = [
  {
    label: 'Deposit',
    value: ACTION_TYPES.DEPOSIT,
  },
  {
    label: 'Borrow',
    value: ACTION_TYPES.BORROW,
  },
  {
    label: 'Repay',
    value: ACTION_TYPES.REPAY,
  },
  {
    label: 'Withdraw',
    value: ACTION_TYPES.WITHDRAW,
  },
]

export function getBorrowAction(action: ACTION_TYPES): ACTION {
  return BORROW_ACTIONS.find((a) => a.value === action)
}
